import React, { useState, useEffect, useRef } from "react";
import { Offcanvas, Row, Col, Button, Input } from "reactstrap";
import "../FormBuilder.scss";
import FieldBuilder from "../FieldBuilder";

function EditFieldOffcanvas({
  isFieldOffcanvasOpen,
  setIsFieldOffcanvasOpen,
  formBuilderType,
  setFormBuilderType,
  setFormBuilderUpdateData,
  addFormField,
  updateFormField,
  setFormFieldId,
  formFields,
  formOptions,
  formBuilderUpdateData,
  isCopy,
  setCopy,
}) {
  const handleClose = () => {
    setFormBuilderType(null);
    setFormBuilderUpdateData(null);
    setIsFieldOffcanvasOpen(false);
    setCopy(false);
  };

  const [header, setHeader] = useState("");
  const handleRetrieveHeader = (value) => {
    setHeader(value);
  };

  // const saveButtonRef = useRef(null);
  // const saveField = () => {
  //   if (saveButtonRef.current) {
  //     saveButtonRef.current.click();
  //   }
  // };

  const fieldBuilderRef = useRef(null);
  const handleSave = () => {
    if (fieldBuilderRef.current) {
      fieldBuilderRef.current.clickSaveButton();
    }
  };

  return (
    <Offcanvas
      direction="end"
      isOpen={isFieldOffcanvasOpen}
      toggle={handleClose}
      style={{ width: "65vw" }}
      scrollable
    >
      <div
        className="offcanvas-header"
        style={{ borderBottom: "1px solid lightgray" }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center w-100">
          <div className="fw-semibold fs-5">
            Edit {header ? header : "Field"}
          </div>
          <div>
            <Button
              className="fb-btn me-2"
              onClick={() => {
                setFormBuilderUpdateData(null);
                setFormBuilderType(null);
                setIsFieldOffcanvasOpen(false);
                setCopy(false);
              }}
            >
              Cancel
            </Button>
            <Button className="fb-save-btn" onClick={handleSave}>
              Save {formBuilderUpdateData ? "Changes" : "Field"}
            </Button>
          </div>
        </div>
      </div>
      <div className="offcanvas-body">
        {formBuilderType && (
          <FieldBuilder
            type={formBuilderType}
            addFormField={addFormField}
            setFormBuilderType={setFormBuilderType}
            formBuilderUpdateData={formBuilderUpdateData}
            updateFormField={updateFormField}
            setFormBuilderUpdateData={setFormBuilderUpdateData}
            setFormFieldId={setFormFieldId}
            formFields={formFields}
            setShowModalSchema={setIsFieldOffcanvasOpen}
            formOptions={formOptions}
            onSetHeader={handleRetrieveHeader}
            ref={fieldBuilderRef}
            isCopy={isCopy}
            setCopy={setCopy}
          />
        )}
      </div>
    </Offcanvas>
  );
}

export default EditFieldOffcanvas;
